import { Component } from '@angular/core';
import { InvestmentFlowService } from '../../../../core/services/Investment-flow/investment-flow.service';

@Component({
  selector: 'app-hero-section',
  imports: [],
  templateUrl: './hero-section.component.html',
  styleUrl: './hero-section.component.css',
})
export class HeroSectionComponent {
  constructor(public flow: InvestmentFlowService){}


}
